import styled from 'styled-components';

import { FinancesPeriod } from '../../../utils/financesUtils';

const PERIODS: { value: FinancesPeriod; label: string }[] = [
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
  { value: 'year', label: 'Year' },
];

const Track = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.colors.extraLight};
  border-radius: 999px;
  padding: 4px;
  gap: 2px;
`;

interface TabProps {
  $active: boolean;
}

const Tab = styled.button<TabProps>`
  flex: 1;
  border: none;
  background: ${(props) => (props.$active ? props.theme.colors.white : 'transparent')};
  border: ${(props) => (props.$active ? `2px solid ${props.theme.colors.primary}` : '2px solid transparent')};
  border-radius: 999px;
  padding: 6px 0;
  font-size: 14px;
  font-weight: ${(props) => (props.$active ? 'bold' : 'normal')};
  color: ${(props) => (props.$active ? props.theme.colors.primary : props.theme.colors.dark)};
  cursor: pointer;
  transition: all 0.15s ease;

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.primary};
    outline-offset: 2px;
  }
`;

interface PeriodTabsProps {
  period: FinancesPeriod;
  onChange: (period: FinancesPeriod) => void;
}

const PeriodTabs = ({ period, onChange }: PeriodTabsProps) => {
  return (
    <Track role="tablist" aria-label="Time period">
      {PERIODS.map(({ value, label }) => (
        <Tab
          key={value}
          role="tab"
          aria-selected={period === value}
          $active={period === value}
          onClick={() => onChange(value)}
        >
          {label}
        </Tab>
      ))}
    </Track>
  );
};

export default PeriodTabs;
